import React from "react";
import {Button,} from "@mui/material";
import RefreshIcon from '@mui/icons-material/Refresh';

export default function DHButtonRefresh({ label, disabled, onClick}) {

    return <Button variant="contained" disabled={disabled} onClick={() => onClick()}
                   startIcon={<RefreshIcon size={20}/>} style={{textTransform: 'none', letterSpacing:"0.1em"}}>{label}</Button>
}